import React from "react";

interface TermsProps {
  title: string;
  content: string;
}

const Terms: React.FC<TermsProps> = ({ title, content }) => {
  return (
    <>
      <h2 className="text-3xl sm:text-4xl px-4 md:px-6 mb-8 md:mb-16 uppercase">
        {title || ""}
      </h2>
      <div className="prose max-w-max px-4 md:px-6" dangerouslySetInnerHTML={{ __html: content }} />
    </>
  );
};

export default Terms;
